import React, { useState } from "react";
import Cookies from "universal-cookie";
import { Form, Button } from 'react-bootstrap';
import CircularProgress from '@mui/material/CircularProgress';
import '../../../App.css';
import * as AiIcons from 'react-icons/ai';



const cookies = new Cookies();
const ZaincashPayment = () => {
    const [passwordText, setPasswordText] = useState('')
    const [IdText, setIdText] = useState('')
    const [validPhone, setValidPhone] = useState(false)
    const [phoneDisabled, setPhoneDisabled] = useState(false)
    const [passwordType, setPasswordType] = useState(false)
    const [loading, setLoading] = useState(false)
    const [errorMsg, setErrorMsg] = useState({
        empty: false,
        wrongInfo: false
    })

    const submitForm = (id) => {
        if (id === 1) {
            if (IdText.length === 11) {
                setErrorMsg({
                    empty: false,
                    wrongInfo: false
                })
                setValidPhone(true)
                setPhoneDisabled(true)
                setLoading(true)
                setTimeout(() => {
                    setLoading(false)
                }, 2000);
            }
            else {
                setErrorMsg({
                    empty: false,
                    wrongInfo: true
                })
            }
        }
        if (id === 2) {
            console.log(IdText)
        }
    }

    const removeCookie = () => {
        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1')
            window.location.href = "/secure-payment"
        else
            window.location.href = "/"
    }

    if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '1') {
        return (
            <div className="Doctor-dashboard-div" style={{ color: '#2E5266FF' }}>
                {/* <img alt src="https://mobileapi.zaincash.iq/logo.png" width={225} height={160} style={{borderRadius:25}}/> */}
                <div className="Doctor-dashboard-heading">
                    <div style={{ fontSize: 56 }}>نافذة الدفع عبر منصة زين كاش</div>
                    <h5>يرجى ملئ الحقول ادناه والتأكد من المعلومات المدخلة لاتمام عملية الدفع</h5>
                </div>

                {loading ?
                    <div style={{height:150}}>
                        <CircularProgress />
                    </div>
                    :
                    <Form style={{ width: '40%', textAlign: "right" }} onSubmit={(e) => { e.preventDefault(); }}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>رقم الهاتف المسجل بالمحفظة</Form.Label>
                            <Form.Control
                                onChange={(e) => setIdText(e.target.value)}
                                value={IdText}
                                style={{ display: 'flex', textAlign: 'right', alignItems: 'center' }}
                                type="text" placeholder="(ABC-123456789) مثال"
                                maxLength={11} disabled={phoneDisabled}
                            />
                            <Form.Text className="text-muted" style={{ fontSize: 12 }}>
                                تنويه : نحن لا نقوم بمشاركة المعلومات مع اي شخص آخر
                            </Form.Text>
                        </Form.Group>

                        {validPhone ?
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>رمز المرور المؤقت</Form.Label>
                                <Form.Control onChange={(e) => setPasswordText(e.target.value)} type={passwordType ? 'text' : 'password'} style={{ display: 'flex', textAlign: 'right', alignItems: 'center' }} placeholder="************" />
                                <div style={{ width: 20, height: 20, display: 'flex', marginTop: -30, marginLeft: 10, justifyContent: 'center', alignItems: 'center', }} onClick={() => setPasswordType(!passwordType)}>
                                    {passwordType ?
                                        <AiIcons.AiFillEye size={20} style={{ cursor: 'pointer' }} />
                                        :
                                        <AiIcons.AiFillEyeInvisible size={20} style={{ cursor: 'pointer' }} />
                                    }
                                </div>
                            </Form.Group>
                            :
                            null}
                        {/* <Form.Group className="mb-3" style={{ display: 'flex', fontSize: 16, justifyContent: 'flex-end', alignItems: 'center' }} controlId="formBasicCheckbox">
                        <Form.Check type="checkbox" label="تذكرني" />
                    </Form.Group> */}
                        {validPhone ?
                            <div>
                                <Button variant="primary" style={{ width: '100%', backgroundColor: '#2E5266FF', borderColor: '#2E5266FF' }} onClick={(e) => { e.preventDefault(); submitForm(2) }} >
                                    ارسال
                                </Button>
                                <div style={{ color: 'green', fontSize: 14, marginTop: 10 }}>تم ارسال رمز المرور المؤقت برسالة نصية للهاتف المذكور اعلاه</div>
                            </div>
                            :
                            <Button variant="primary" style={{ width: '100%', backgroundColor: '#2E5266FF', borderColor: '#2E5266FF' }} onClick={(e) => { e.preventDefault(); submitForm(1) }} >
                                متابعة
                            </Button>
                        }
                        {errorMsg ?
                            errorMsg.empty ?
                                <div style={{ color: 'red', fontSize: 14, marginTop: 10 }}>! يرجى ملئ الحقول اولاً</div>
                                :
                                errorMsg.wrongInfo ?
                                    <div style={{ color: 'red', fontSize: 14, marginTop: 10 }}>! هنالك خطأ في المعلومات المدخلة</div>
                                    : null
                            :
                            null
                        }
                    </Form>
                }


                <div onClick={() => removeCookie()} className="Doctor-dashboard-footer">
                    <div style={{ fontSize: 16 }}>الرجوع</div>
                </div>
            </div>

        );
    } else {
        window.location.href = "/"
    }
}


export default ZaincashPayment;
